import moment from "moment";
import { METODI_PAGAMENTO } from "./metodoPagamento";
import { contributoVerdeBluPeriodo } from "./verdeBluUtility";
export default {
  props: {
    noButton: Boolean,
    cliente_prop: {
      type: String,
      default: null,
    },
    totale_documento: {
      type: Number,
      default: 0,
    },
    tot_iva_documento: {
      type: Number,
      default: 0,
    },
    tot_trasporto_documento: {
      type: Number,
      default: 0,
    },
    tot_iva_trasporto_documento: {
      type: Number,
      default: 0,
    },
    ordine_prop: {
      type: String,
      default: null,
    },
    ordine_id_prop: {
      type: String,
      default: null,
    },
    conteggio_prop: {
      type: String,
      default: null,
    },
    sub_conteggio_prop: {
      type: Object,
      default: null,
    },
  },
  data() {
    const currentYear = moment().year();
    return {
      dialog: false,
      cliente: null,
      verde: false,
      importo_imponibile: 0,
      importo_iva: 0,
      importo_totale: 0,
      importo_trasporto: 0,
      importo_iva_trasporto: 0,
      menu_data: false,
      data: moment().format("YYYY-MM-DD"),
      items_tipo: [
        { id: 1, tipo: "Debito" },
        { id: 2, tipo: "Pagamento Cliente" },
        { id: 3, tipo: "Fattura di Copertura" },
      ],
      saldato: false,
      // Fattura Anticipata/Posticipata segnata come pagata subito in fase
      // di creazione: metodo con cui è arrivato il pagamento, e
      // l'eventuale estinzione immediata del credito residuo per il caso
      // in cui il cliente abbia versato solo l'IVA (nessuna erosione
      // futura prevista — vedi estingui_credito).
      metodoPagamentoFattura: METODI_PAGAMENTO[0].value,
      estinguiResiduoFattura: false,
      tipo: 1,
      ordine: this.ordine_prop,
      ordine_id: this.ordine_id_prop,
      id_conteggio: this.conteggio_prop,
      id_sub_conteggio: this.sub_conteggio_prop
        ? this.sub_conteggio_prop.id.$oid
        : null,
      ddt: null,
      note: null,
      valid: false,
      loadingSalva: false,
      alertError: false,
      alertOk: false,
      anni_rif: [
        `/${(currentYear - 2).toString().slice(-2)}`,
        `/${(currentYear - 1).toString().slice(-2)}`,
        `/${currentYear.toString().slice(-2)}`,
      ],
      anno_rif: `/${currentYear.toString().slice(-2)}`,
      errorMessage: null,
      trasp_gratuito: false,
      creditiDisponibili: [],
      erodeCredito: false,
      idCreditoErosione: null,
      warningMessage: null,
      alertWarning: false,
      // Pagamento (anche solo un acconto) già ricevuto, da registrare
      // subito in fase di creazione del debito.
      registraPagamento: false,
      importoPagamentoIniziale: null,
      metodoPagamentoIniziale: METODI_PAGAMENTO[0].value,
      metodiPagamento: METODI_PAGAMENTO,
      // Pagamento Cliente (tipo=2): metodo con cui è arrivato il denaro, e
      // distribuzione facoltativa sui debiti aperti del cliente (stessa
      // modalità verde/blu) da coprire subito. L'eventuale residuo non
      // distribuito resta come credito disponibile per il futuro.
      metodoPagamentoCredito: METODI_PAGAMENTO[0].value,
      debitiAperti: [],
      coperturaDebiti: {},
      // Fattura Anticipata (tipo=3): debiti verdi già esistenti che questa
      // fattura può erodere subito in fase di creazione — pagamento
      // fresco tracciato, anche parziale per riga, esattamente come
      // coperturaDebiti sopra per un Pagamento Cliente (round 44). Il
      // termine "anticipata" qui decade un po' (i debiti sono precedenti,
      // non successivi), ma il meccanismo è lo stesso, solo con la
      // direzione temporale invertita.
      debitiErodibili: [],
      erosioneDebiti: {},
      // Guardia usata da apriPerCoperturaFattura() per evitare che un
      // caricamento "normale" (innescato dai watcher su tipo/cliente)
      // sovrascriva la pre-selezione mentre lei sta ancora componendola.
      omettiAutoCaricamentoErodibili: false,
    };
  },
  watch: {
    verde() {
      if (this.tipo == 3) {
        // Il watcher su tipo forza già verde=false quando si entra in
        // tipo=3 (Fattura Anticipata/Posticipata, sempre blu): qui non
        // c'è nessuna logica di tipo 1/2 da applicare (importo_totale è
        // calcolato in modo diverso per la fattura, vedi importo_imponibile_fattura).
        return;
      }
      // L'erosione richiede stessa modalità (verde/blu) tra debito e
      // credito: cambiando modalità, la selezione precedente non è più
      // valida (l'elenco dei crediti coerenti cambia di conseguenza).
      this.erodeCredito = false;
      this.idCreditoErosione = null;
      if (this.verde) {
        if (this.importo_imponibile > 0) {
          this.importo_totale = (
            this.importo_imponibile + this.importo_trasporto
          ).toFixed(2);
        }
      } else if (!this.verde) {
        if (this.importo_imponibile > 0) {
          this.importo_totale = (
            this.importo_imponibile +
            this.importo_iva +
            this.importo_trasporto +
            this.importo_iva_trasporto
          ).toFixed(2);
        }
      }
      if (this.tipo == 2) {
        // Cambia la modalità (verde/blu): la lista dei debiti coprIbili
        // cambia di conseguenza.
        this.caricaDebitiAperti();
      }
      // Nessun ramo per tipo==3: la Fattura Anticipata/Posticipata è
      // sempre blu (lo switch è nascosto per questo tipo, verde non può
      // cambiare mentre resta selezionata), e i debiti che può erodere
      // sono sempre verdi a prescindere — vedi caricaDebitiErodibili().
    },
    cliente() {
      if (!this.cliente_prop) {
        this.ordine_id = this.ordini[0]?._id.$oid;
      }
      this.caricaCreditiDisponibili();
      if (this.tipo == 2) {
        this.caricaDebitiAperti();
      } else if (this.tipo == 3) {
        this.caricaDebitiErodibili();
      }
    },
    tipo(valore) {
      if (valore != 1) {
        this.erodeCredito = false;
        this.idCreditoErosione = null;
        this.registraPagamento = false;
      }
      if (valore != 3) {
        // Reset di sicurezza: "saldato" qui è condiviso con la checkbox
        // di tipo=3 (l'unico tipo dove questo form lo espone davvero) —
        // senza reset, un valore lasciato a true passando da tipo=3 a
        // tipo=1 creerebbe un debito segnato pagato senza nessuna
        // allocazione reale a supporto (lo stesso "stato legacy" che il
        // resto di questo lavoro cerca di eliminare, vedi round 8).
        this.saldato = false;
        this.metodoPagamentoFattura = METODI_PAGAMENTO[0].value;
        this.estinguiResiduoFattura = false;
      }
      if (valore == 2) {
        this.caricaDebitiAperti();
      } else {
        this.debitiAperti = [];
        this.coperturaDebiti = {};
      }
      if (valore == 3) {
        // Una Fattura Anticipata/Posticipata è sempre blu (atto fiscale
        // formale, proprio numero): mai un flag scelto, a differenza di
        // tipo 1/2 dove lo switch resta libero. Lo switch è nascosto nel
        // template per questo tipo — forziamo qui lo stato coerente.
        this.verde = false;
        this.caricaDebitiErodibili();
      } else {
        this.debitiErodibili = [];
        this.erosioneDebiti = {};
      }
    },
    erodeCredito(valore) {
      // Incompatibile con un pagamento fresco: l'erosione copre sempre
      // l'intero debito, niente copertura mista.
      if (valore) {
        this.registraPagamento = false;
      }
    },
    saldato(valore) {
      // "Il cliente ha pagato solo l'IVA" ha senso solo se la fattura è
      // segnata come pagata: se l'utente la despunta, riparte da zero.
      if (!valore) {
        this.estinguiResiduoFattura = false;
      }
    },
    registraPagamento(valore) {
      if (valore) {
        this.erodeCredito = false;
        // Di default copre l'intero importo (comodo per il caso "pagato
        // tutto subito"); l'utente può ridurlo per registrare un acconto.
        this.importoPagamentoIniziale = parseFloat(this.importo_totale) || null;
      }
    },
    totale_documento() {
      this.importo = (
        this.totale_documento +
        this.totale_documento * 0.1
      ).toFixed(2);
    },
    sub_conteggio_prop() {
      this.id_sub_conteggio = this.sub_conteggio_prop
        ? this.sub_conteggio_prop.id.$oid
        : null;
    },
  },
  computed: {
    items() {
      return this.$store.getters.get_clienti;
    },
    dataFormatted() {
      return moment(this.data).format("dddd DD MMMM YYYY");
    },
    ordini() {
      return this.$store.getters.get_ordini_attivi.filter(
        (ordine) => ordine.iva == this.cliente
      );
    },
    tipo_consegna() {
      return this.$store.getters.get_ordine_by_id(this.ordine_id)?.ritiro_cod;
    },
    subconteggi() {
      return (
        this.ordini.find((ord) => ord._id.$oid == this.ordine_id)
          ?.subConteggio || []
      );
    },
    computedDdt: {
      get() {
        return this.verde ? null : this.ddt;
      },
      set(value) {
        if (!this.verde) {
          this.ddt = value;
        }
      },
    },
    contabili_non_saldate() {
      return this.$store.getters.get_contabili_non_saldate_by_cliente(
        this.cliente
      );
    },
    groupedByDay() {
      let grouped = {};
      this.contabili_non_saldate.forEach((contabile) => {
        const day = moment(contabile.ts * 1000).format("dddd DD MMMM YYYY");
        if (!grouped[day]) {
          grouped[day] = {
            contabili: [],
            totale: 0,
            tot_verde: 0,
            tot_blu: 0,
          };
        }
        const { verde, blu } = contributoVerdeBluPeriodo(contabile);
        grouped[day].contabili.push(contabile);
        grouped[day].totale += contabile.importo;
        grouped[day].tot_verde += verde;
        grouped[day].tot_blu += blu;
      });

      // Ordina le contabili di ogni giorno per il numero prima dello slash nel ddt
      Object.keys(grouped).forEach((day) => {
        grouped[day].contabili.sort((a, b) => {
          // Estrai il numero prima dello slash
          const numA = parseInt((a.ddt || "").split("/")[0], 10);
          const numB = parseInt((b.ddt || "").split("/")[0], 10);
          return numA - numB;
        });
      });

      return grouped;
    },
    groupedByMonth() {
      let grouped = {};
      this.contabili_non_saldate.forEach((contabile) => {
        const month = moment(contabile.ts * 1000).format("MMMM YYYY");
        if (!grouped[month]) {
          grouped[month] = {
            mese: month,
            contabili: [],
            totale: 0,
            tot_verde: 0,
            tot_blu: 0,
          };
        }
        const { verde, blu } = contributoVerdeBluPeriodo(contabile);
        grouped[month].contabili.push(contabile);
        grouped[month].totale += contabile.importo;
        grouped[month].tot_verde += verde;
        grouped[month].tot_blu += blu;
      });
      return grouped;
    },
    hide_iva() {
      return (
        this.roundToTwo(parseFloat(this.importo_totale)) !=
        this.roundToTwo(
          parseFloat(this.importo_imponibile) +
            parseFloat(this.importo_trasporto) +
            parseFloat(this.importo_iva) +
            parseFloat(this.importo_iva_trasporto)
        )
      );
    },
    importo_imponibile_fattura(){
      return this.importo_totale / 0.10
    },
    // Una Fattura Anticipata/Posticipata (tipo=3) eroda sempre e solo
    // debiti verdi (regolarizza ritiri fuori tracciabilità DDT): compare
    // come fonte solo se questo debito è verde, indipendentemente dal suo
    // proprio verde (sempre blu/formale) — non la regola simmetrica valida
    // per un Pagamento Cliente (tipo=2), dove serve la stessa modalità.
    creditiDisponibiliCoerenti() {
      return this.creditiDisponibili.filter((c) =>
        c.tipo === 3 ? this.verde === true : !!c.verde === !!this.verde
      );
    },
    // Il credito attualmente selezionato per l'erosione — sempre un
    // pagamento fresco tracciato, parziale e componibile, qualunque sia
    // il tipo (round 44: non c'è più distinzione di comportamento tra
    // Fattura Anticipata e Pagamento Cliente qui).
    creditoErosioneSelezionato() {
      return this.creditiDisponibiliCoerenti.find(
        (c) => c.id === this.idCreditoErosione
      );
    },
    // Pagamento Cliente: quanto è già stato distribuito sui debiti aperti
    // selezionati, e quanto resta (diventerà il credito disponibile).
    totaleCopertoDebiti() {
      return this.debitiAperti.reduce((tot, d) => {
        const importo = parseFloat(this.coperturaDebiti[d.id]) || 0;
        return tot + importo;
      }, 0);
    },
    residuoPagamentoNonAssegnato() {
      return this.roundToTwo(
        (parseFloat(this.importo_totale) || 0) - this.totaleCopertoDebiti
      );
    },
    // Fattura Anticipata: quanto è già stato distribuito sui debiti verdi
    // selezionati (importo per riga, editabile e parziale come per un
    // Pagamento Cliente — round 44), e quanto imponibile resta.
    totaleErosoSelezionato() {
      return this.debitiErodibili.reduce((tot, d) => {
        const importo = parseFloat(this.erosioneDebiti[d.id]) || 0;
        return tot + importo;
      }, 0);
    },
    imponibileNonErosoRimanente() {
      return this.roundToTwo(
        (parseFloat(this.importo_imponibile_fattura) || 0) - this.totaleErosoSelezionato
      );
    },
  },
  methods: {
    roundToTwo(num) {
      return Math.round((num + Number.EPSILON) * 100) / 100;
    },
    // item-text esplicito per il select "Credito da erodere": senza,
    // v-select usa internamente la proprietà "text" (che questi oggetti
    // non hanno) e in alcuni punti finisce per mostrare "[object Object]"
    // invece del contenuto degli slot item/selection.
    testoCredito(item) {
      const tipo = item.tipo === 3 ? "Fattura di copertura" : "Pagamento Cliente";
      const ddt = item.ddt ? " — DDT " + item.ddt : "";
      return `${tipo}${ddt} — residuo € ${item.residuo.toFixed(2)}`;
    },
    format_ts_to_date(ts) {
      return moment.unix(ts).format("DD/MM/YYYY");
    },
    salvaContabile() {
      if (this.tipo == 2 && this.residuoPagamentoNonAssegnato < 0) {
        // Guardia lato form: il backend blocca comunque, ma qui evitiamo
        // la richiesta inutile e diamo un feedback immediato.
        this.errorMessage =
          "L'importo distribuito sui debiti supera il totale del pagamento.";
        this.alertError = true;
        return;
      }
      if (this.tipo == 3 && this.imponibileNonErosoRimanente < 0) {
        this.errorMessage =
          "L'importo distribuito sui debiti selezionati supera l'imponibile della fattura.";
        this.alertError = true;
        return;
      }
      this.loadingSalva = true;
      this.$store
        .dispatch("create_contabile", {
          cliente: this.cliente,
          verde: this.verde,
          importo:
            this.tipo == 1 || this.tipo == 3
              ? this.importo_totale
              : -this.importo_totale,
          ts: moment(this.data).format("X"),
          tipo: this.tipo,
          id_ordine:
            this.tipo == 2 || this.tipo == 3
              ? ""
              : this.ordine_id
              ? this.ordine_id
              : "",
          id_sub_conteggio:
            this.tipo == 2 || this.tipo == 3
              ? ""
              : this.id_sub_conteggio
              ? this.id_sub_conteggio
              : "",
          // Il DDT si usa per tipo 1 (Debito, non verde) e per tipo 3
          // (Fattura Anticipata): il campo nel form è abilitato e
          // obbligatorio per entrambi. tipo 2 (nota di credito) non ha mai
          // un DDT.
          ddt:
            this.tipo == 1 || this.tipo == 3
              ? !this.verde
                ? this.ddt + this.anno_rif
                : ""
              : "",
          note: this.note,
          saldato: this.saldato,
          id_conteggio: this.id_conteggio ? this.id_conteggio : "",
          // Solo per tipo=3 (Fattura Anticipata): persiste l'imponibile
          // della fattura, così può essere eroso in seguito dai debiti
          // (DDT) delle consegne reali. Prima veniva solo calcolato a
          // video e mai salvato.
          importo_imponibile:
            this.tipo == 3 ? this.importo_imponibile_fattura : null,
          // Erode subito, in fase di creazione, un credito esistente della
          // stessa modalità (verde/blu) invece di richiedere un pagamento
          // fresco. Copre sempre l'intero importo del debito; il suo
          // saldato resta poi vincolato a quello del credito scelto.
          id_credito_erosione:
            this.tipo == 1 && this.erodeCredito
              ? this.idCreditoErosione
              : null,
          // Pagamento (anche solo un acconto) già ricevuto, da registrare
          // subito insieme al debito — incompatibile con l'erosione
          // (mutua esclusione già garantita dai watcher).
          pagamento_iniziale:
            this.tipo == 1 && this.registraPagamento && this.importoPagamentoIniziale > 0
              ? {
                  importo: this.importoPagamentoIniziale,
                  metodo_pagamento: this.metodoPagamentoIniziale,
                }
              : null,
          // Per tipo=2 (Pagamento Cliente): con cosa è arrivato il denaro,
          // e l'eventuale distribuzione immediata sui debiti aperti
          // selezionati (stessa modalità verde/blu) — il residuo non
          // distribuito resta come credito disponibile per il futuro. Per
          // tipo=3 (Fattura Anticipata), solo se segnata come pagata
          // subito: con cosa è arrivato il pagamento.
          metodo_pagamento:
            this.tipo == 2
              ? this.metodoPagamentoCredito
              : this.tipo == 3 && this.saldato
              ? this.metodoPagamentoFattura
              : null,
          copertura_debiti:
            this.tipo == 2
              ? Object.entries(this.coperturaDebiti)
                  .filter(([, importo]) => parseFloat(importo) > 0)
                  .map(([id_debito, importo]) => ({
                    id_debito,
                    importo: parseFloat(importo),
                  }))
              : null,
          // Solo per tipo=3 (Fattura Anticipata): debiti verdi già
          // esistenti scelti per essere erosi subito da questa fattura —
          // pagamento fresco tracciato, anche parziale per riga (round
          // 44, stesso meccanismo di copertura_debiti sopra).
          debiti_da_erodere:
            this.tipo == 3
              ? Object.entries(this.erosioneDebiti)
                  .filter(([, importo]) => parseFloat(importo) > 0)
                  .map(([id_debito, importo]) => ({
                    id_debito,
                    importo: parseFloat(importo),
                  }))
              : null,
          // Solo per tipo=3, segnata come pagata e con "il cliente ha
          // pagato solo l'IVA" spuntato: estingue subito l'eventuale
          // imponibile rimasto non eroso da nessun debito selezionato
          // sopra, invece di lasciarlo in attesa indefinita di
          // un'erosione che potrebbe non arrivare mai.
          estingui_residuo: this.tipo == 3 && this.saldato && this.estinguiResiduoFattura,
        })
        .then((response) => {
          this.loadingSalva = false;
          this.$emit("new_insert");
          const haWarning = !!(response.data && response.data.warning);
          if (haWarning) {
            this.warningMessage = response.data.warning;
            this.alertWarning = true;
          } else {
            this.alertOk = true;
          }
          // Il warning (es. sovra-erosione di un credito) resta visibile
          // più a lungo del semplice ok, perché è un'informazione da
          // leggere consapevolmente, non solo una conferma di routine.
          setTimeout(() => {
            this.alertOk = false;
            this.alertWarning = false;
            this.dialog = false;
            this.cliente = null;
            this.verde = false;
            this.importo = 0.0;
            this.data = moment().format("YYYY-MM-DD");
            this.tipo = 1;
            this.ordine = null;
            this.ordine_id = null;
            this.saldato = false;
            this.ddt = null;
            this.note = null;
            this.erodeCredito = false;
            this.idCreditoErosione = null;
            this.registraPagamento = false;
            this.importoPagamentoIniziale = null;
            this.metodoPagamentoIniziale = METODI_PAGAMENTO[0].value;
            this.metodoPagamentoCredito = METODI_PAGAMENTO[0].value;
            this.debitiAperti = [];
            this.coperturaDebiti = {};
            this.debitiErodibili = [];
            this.erosioneDebiti = {};
            this.metodoPagamentoFattura = METODI_PAGAMENTO[0].value;
            this.estinguiResiduoFattura = false;
          }, haWarning ? 4500 : 1500);
        })
        .catch((err) => {
          this.errorMessage =
            err.response?.data?.message || "Errore durante il salvataggio";
          this.alertError = true;
          this.loadingSalva = false;
        });
    },
    rimuovi_trasporto() {
      this.importo_trasporto = 0;
      this.importo_iva_trasporto = 0;
      this.importo_totale = (
        this.importo_imponibile + (!this.verde ? this.importo_iva : 0)
      ).toFixed(2);
      this.trasp_gratuito = true;
    },
    aggiungi_trasporto() {
      let trasporto = this.$store.getters.get_trasporto;
      let cliente = this.$store.getters.get_cliente_by_iva(this.cliente);
      if (cliente.listino == "1") {
        this.importo_trasporto = trasporto.prezzo_listino_1;
      } else if (cliente.listino == "2") {
        this.importo_trasporto = trasporto.prezzo_listino_2;
      } else if (cliente.listino == "3") {
        this.importo_trasporto = trasporto.prezzo_listino_3;
      }
      this.importo_iva_trasporto = this.importo_trasporto * 0.1;
      this.importo_totale = (
        this.importo_imponibile +
        (!this.verde ? this.importo_iva : 0) +
        this.importo_trasporto +
        (!this.verde ? this.importo_iva_trasporto : 0)
      ).toFixed(2);
      this.trasp_gratuito = false;
    },
    open() {
      this.dialog = true;
      // cerco il numero ddt maggiore in tutte le contabili e assegno quel valore +1 a questo ddt
      this.ddt = this.$store.getters.get_max_contabile_ddt + 1;
      this.cliente = this.cliente_prop;
      this.ordine_id = this.ordine_id_prop;
      this.conteggio_id = this.conteggio_prop;
      this.importo_imponibile = this.totale_documento;
      this.importo_iva = this.tot_iva_documento;
      this.importo_trasporto = this.tot_trasporto_documento;
      this.importo_iva_trasporto = this.tot_iva_trasporto_documento;
      this.importo_totale = (
        this.importo_imponibile +
        this.importo_iva +
        this.importo_trasporto +
        this.importo_iva_trasporto
      ).toFixed(2);
      this.trasp_gratuito = this.tot_trasporto_documento == 0 ? true : false;
      this.caricaCreditiDisponibili();
    },
    // "Crea coperture con Fattura": apre il dialog già pre-compilato per
    // creare una Fattura Anticipata/Posticipata che eroda esattamente i
    // debiti verdi selezionati dalla lista principale — stessa
    // funzionalità del round precedente (sezione "debiti da erodere"),
    // ma partendo dalla selezione invece che dal form. `debitiSelezionati`
    // è un array di { id, residuo }.
    apriPerCoperturaFattura(clienteIva, debitiSelezionati) {
      this.dialog = true;
      this.ddt = this.$store.getters.get_max_contabile_ddt + 1;
      this.tipo = 3;
      this.verde = false;
      this.erodeCredito = false;
      this.idCreditoErosione = null;
      this.registraPagamento = false;
      this.cliente = clienteIva;

      const idsSelezionati = new Set(debitiSelezionati.map((d) => d.id));
      const totaleSelezionato = debitiSelezionati.reduce((tot, d) => tot + d.residuo, 0);
      // Il campo visibile "Importo IVA (Fattura Anticipata)" è di fatto la
      // sola IVA: l'imponibile persistito si ricava dividendo per
      // l'aliquota (vedi importo_imponibile_fattura). Precompiliamo al
      // contrario per far combaciare l'imponibile con il totale dei
      // debiti selezionati.
      this.importo_totale = this.roundToTwo(totaleSelezionato * 0.10);

      // Fetch dedicato (non il caricaDebitiErodibili() normale, messo in
      // pausa dalla guardia sotto): serve applicare la pre-selezione
      // esattamente su QUESTA risposta, senza rischiare che un
      // caricamento concorrente innescato dai watcher su tipo/cliente la
      // sovrascriva risolvendo dopo.
      this.omettiAutoCaricamentoErodibili = true;
      this.$store
        .dispatch("fetch_debiti_aperti_cliente", {
          iva: clienteIva,
          verde: true,
        })
        .then((debiti) => {
          this.debitiErodibili = debiti;
          const selezione = {};
          debiti.forEach((d) => {
            if (idsSelezionati.has(d.id)) {
              // Precompila al residuo pieno (round 44: ora editabile,
              // come per un Pagamento Cliente — l'utente può ridurlo).
              selezione[d.id] = d.residuo;
            }
          });
          this.erosioneDebiti = selezione;
        })
        .catch(() => {
          this.debitiErodibili = [];
          this.erosioneDebiti = {};
        })
        .finally(() => {
          this.omettiAutoCaricamentoErodibili = false;
        });
    },
    caricaCreditiDisponibili() {
      if (!this.cliente) {
        this.creditiDisponibili = [];
        return;
      }
      this.$store
        .dispatch("fetch_crediti_disponibili_cliente", this.cliente)
        .then((crediti) => {
          this.creditiDisponibili = crediti;
        })
        .catch(() => {
          this.creditiDisponibili = [];
        });
    },
    caricaDebitiAperti() {
      if (!this.cliente || this.tipo != 2) {
        this.debitiAperti = [];
        this.coperturaDebiti = {};
        return;
      }
      this.$store
        .dispatch("fetch_debiti_aperti_cliente", {
          iva: this.cliente,
          verde: this.verde,
        })
        .then((debiti) => {
          this.debitiAperti = debiti;
          this.coperturaDebiti = {};
        })
        .catch(() => {
          this.debitiAperti = [];
          this.coperturaDebiti = {};
        });
    },
    // Fattura Anticipata/Posticipata: debiti aperti che questa fattura può
    // erodere subito — sempre e solo VERDI (ritiri fuori tracciabilità
    // DDT, la fattura stessa è sempre blu, non la regola simmetrica di un
    // Pagamento Cliente). Un debito con già un acconto parziale resta
    // eleggibile (pagamento fresco componibile, round 44) — l'unica
    // esclusione è un debito vincolato a un'erosione storica, già gestita
    // da get_debiti_aperti_cliente.
    caricaDebitiErodibili() {
      if (!this.cliente || this.tipo != 3) {
        this.debitiErodibili = [];
        this.erosioneDebiti = {};
        return;
      }
      if (this.omettiAutoCaricamentoErodibili) {
        // apriPerCoperturaFattura() sta già gestendo lei stessa questo
        // fetch con una pre-selezione da applicare: un caricamento
        // "normale" innescato nel frattempo dai watcher su tipo/cliente
        // cancellerebbe quella pre-selezione (race condition) se risolvesse
        // dopo. Saltato finché non è lei a rimuovere la guardia.
        return;
      }
      this.$store
        .dispatch("fetch_debiti_aperti_cliente", {
          iva: this.cliente,
          verde: true,
        })
        .then((debiti) => {
          this.debitiErodibili = debiti;
          this.erosioneDebiti = {};
        })
        .catch(() => {
          this.debitiErodibili = [];
          this.erosioneDebiti = {};
        });
    },
    // Precompila la distribuzione dell'erosione partendo dal debito più
    // vecchio, riempiendo ciascuno fino al suo residuo finché non si
    // esaurisce l'imponibile della fattura. Resta comunque modificabile a
    // mano dopo — stesso pattern di precompilaDistribuzioneFifo sotto.
    precompilaErosioneFifo() {
      const importoDisponibile = parseFloat(this.importo_imponibile_fattura) || 0;
      let residuo = importoDisponibile;
      const nuovaErosione = {};
      for (const debito of this.debitiErodibili) {
        if (residuo <= 0) break;
        const quota = Math.min(residuo, debito.residuo);
        if (quota > 0) {
          nuovaErosione[debito.id] = this.roundToTwo(quota);
          residuo = this.roundToTwo(residuo - quota);
        }
      }
      this.erosioneDebiti = nuovaErosione;
    },
    // Precompila la distribuzione partendo dal debito più vecchio,
    // riempiendo ciascuno fino al suo residuo finché non si esaurisce
    // l'importo del pagamento. Resta comunque modificabile a mano dopo.
    precompilaDistribuzioneFifo() {
      const importoDisponibile = parseFloat(this.importo_totale) || 0;
      let residuo = importoDisponibile;
      const nuovaCopertura = {};
      for (const debito of this.debitiAperti) {
        if (residuo <= 0) break;
        const quota = Math.min(residuo, debito.residuo);
        if (quota > 0) {
          nuovaCopertura[debito.id] = this.roundToTwo(quota);
          residuo = this.roundToTwo(residuo - quota);
        }
      }
      this.coperturaDebiti = nuovaCopertura;
    },
  },
};
